import {RTS_COVERAGE_CONFIRMED} from '@constants/variables';
import {convertToInt} from '@utils/helpers';
import {isRedStatusLabel} from '@utils/status';
import {isValidMatchStatusId} from '@modules/liveControl/utils/helpers';

const MATCH_STATUS_ABANDONED = 90;

export const getWarnings = (row) => {
    let rules;

    if (row.stage_id) {
        rules = [
            [isRedStatusLabel(row.event_status_id), row.event_status],
        ];
    } else {
        rules = [
            [row.property_licence_tech_setup_is_tv_streaming && null !== row.match_tv_streaming_encoder_id, 'TV Streaming'],
            [RTS_COVERAGE_CONFIRMED === row.match_rts_coverage_id, 'RTS'],
            [!row.match_has_live_scout, 'No scout'],
            [row.home_team_is_excluded, 'Excluded home competitor'],
            [row.away_team_is_excluded, 'Excluded away competitor'],
            [!row.match_has_live_odds, 'No LO'],
            [row.match_has_underage_competitors, 'Underage competitors'],
            [row.match_is_cancelled, 'Cancelled'],
            [row.match_is_postponed, 'Postponed'],
            [row.match_is_walkover, 'W.O.'],
            [
                row.match_is_abandoned && MATCH_STATUS_ABANDONED !== convertToInt(row.match_status_id),
                'Abandoned',
            ],
            [isValidMatchStatusId(row.match_status_id), row.match_status_name],
            [Boolean(row.match_schedule_state), row.match_schedule_state],
            [isRedStatusLabel(row.event_status_id), row.event_status],
        ];
    }

    return rules.reduce((acc, [cond, label]) => (cond && label ? acc.concat(label) : acc), []);
};
